import(/* webpackMode: "eager" */ "/app/src/app/features/page.tsx");
